const FILL_FORM_KEY = 'fill-form';

function windowCustomEventSend(key: string, data?: any) {
  const event = new CustomEvent(key, data);
  return window.dispatchEvent(event);
}

export function dispatchFillFormEvent() {
  return windowCustomEventSend(FILL_FORM_KEY);
}

export function addFillFormListener(callback: () => void) {
  window.addEventListener(FILL_FORM_KEY, callback, false);

  return () => removeFillFormListener(callback);
}

export function removeFillFormListener(callback: () => void) {
  window.removeEventListener(FILL_FORM_KEY, callback);
}
